import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import type {FetchFunction} from '../services/fetch'

export const withExternalApiPrefix = (fetch: FetchFunction): FetchFunction => {
  return config => {
    return fetch({
      ...config,
      url: externalApiURL(config.url),
    })
  }
}

export const withCountryCode = (countryCode: string, fetch: FetchFunction): FetchFunction => {
  return config => {
    return fetch({
      ...config,
      url: addQuery(config.url, {country: countryCode}),
    })
  }
}
